import { useAtom } from 'jotai/index';
import { useEffect } from 'react';
import useInputState from './UseInputState';
import {
  isPartnersInputsDirtyAtom,
  partnerSaveAtom,
  selectedPartnerAtom,
} from '../atoms/partnersAtoms';
import PartnersServices from '../services/PartnersServices';

const useSinglePartnerSettings = ({ savePartner }) => {
  const [isSmsEnabled, setIsSmsEnabled, isSmsEnabledError, setIsSmsEnabledError] = useInputState();
  const [smsSenderName, setSmsSenderName, smsSenderNameError, setSmsSenderNameError] = useInputState();

  const [partnerSave, setPartnerSave] = useAtom(partnerSaveAtom);
  const [selectedPartner] = useAtom(selectedPartnerAtom);
  const [, setIsPartnersInputsDirty] = useAtom(isPartnersInputsDirtyAtom);

  const checkForErrors = () => {
    let isError = false;
    if (!isSmsEnabled) {
      setIsSmsEnabledError('Укажите статус');
      isError = true;
    }
    if (!smsSenderName) {
      setSmsSenderNameError('Укажите имя отправителя');
      isError = true;
    }

    return isError;
  };

  const handleSavePartner = () => {
    // const isError = checkForErrors();
    // if (isError) return;

    savePartner({
      ...selectedPartner,
      settings: {
        sms_enabled: isSmsEnabled?.value === 'active',
        sms_sender_name: smsSenderName,
      }
    });
  };

  useEffect(() => {
    if (partnerSave) {
      handleSavePartner();
      setPartnerSave(0);
    }
  }, [partnerSave]);

  useEffect(() => {
    if (!selectedPartner) {
      return setIsPartnersInputsDirty(true);
    }

    // checking if inputs were changed
    const isDirty = (isSmsEnabled?.value === 'active') !== selectedPartner.settings?.sms_enabled || selectedPartner.settings?.sms_sender_name !== smsSenderName;

    // if some state was changed
    setIsPartnersInputsDirty(isDirty);
  });

  useEffect(() => {
    if (!selectedPartner) return;
    setIsSmsEnabled(selectedPartner.settings?.sms_enabled ? { value: 'active', label: 'Включено' } : { value: 'nonActive', label: 'Выключено' }, true);
    setSmsSenderName(selectedPartner.settings?.sms_sender_name || '', true);
  }, [selectedPartner]);

  return {
    values: {
      isSmsEnabled,
      smsSenderName,
    },
    setters: {
      isSmsEnabled: setIsSmsEnabled,
      smsSenderName: setSmsSenderName,
    },
    errors: {
      isSmsEnabled: isSmsEnabledError,
      smsSenderName: smsSenderNameError,
    },
  };
};

export default useSinglePartnerSettings;
